$.fn.LocationFilters = function() {
  let self = this

  self.find('.location-filters__title').click(function() {
    self.maxHeight();
    self.toggleClass('--filters-open')
    self.find('.location-filters__overflow').scrollTop(0);
  })

  $('.location-filters__reset').click(function() {
    self.find('.grid-filters__item.--child .grid-filters__btn.--selected').click();
    self.find('.grid-filters__btn.--selected').click();
    $(this).removeClass('location-filters__reset--visible')
  })

  self.find('.grid-filters__btn').click(function() {
    if (!$(this).closest('.grid-filters__item').hasClass('--child') && $(this).closest('.grid-filters__item').next('.grid-filters__item').hasClass('--child')) {
      if ($(this).hasClass('--selected')) {
        $(this).closest('.grid-filters__item').nextAll('.--child').find('.grid-filters__btn:not(.--selected)').click()
      } else {
        if ($(this).closest('.grid-filters__item').nextAll('.--child').length == $(this).closest('.grid-filters__item').nextAll('.--child').find('.--selected').length) {
          $(this).closest('.grid-filters__item').nextAll('.--child').find('.grid-filters__btn.--selected').click();
        }
      }
    }
    if ($(this).closest('.grid-filters__item').hasClass('--child')) {
      if (!$(this).hasClass('--selected')) {
        $(this).closest('.grid-filters__item').prevAll(':not(.--child)').last().find('.grid-filters__btn.--selected').click()
      } else if ($(this).hasClass('--selected')) {
        let allChildrenAreChecked = true,
        lastParent = $(this).closest('.grid-filters__item').prevAll(':not(.--child)').last()
        lastParent.nextAll('.--child').each(function() {
          if (!$(this).find('.grid-filters__btn').hasClass('--selected')) {
            allChildrenAreChecked = false
          }
        })
        if (allChildrenAreChecked && !lastParent.find('.grid-filters__btn').hasClass('--selected')) {
          lastParent.find('.grid-filters__btn').click()
        }
      }
    }
    if (self.find('.--selected').length) {
      $('.location-filters__reset').addClass('location-filters__reset--visible')
    } else {
      $('.location-filters__reset').removeClass('location-filters__reset--visible')
    }
  })

  self.maxHeight = function () {
    self.css('--max-height', self.find('.location-filters__wrapper').outerHeight() + 'px');
  }

  $(window).click(function() {
    $('.location-filters').removeClass('--filters-open');
  });

  $('.location-filters').click(function(event){
    event.stopPropagation();
  });


  return function() {
    $(window).on('resize load orientationchange', self.maxHeight)
    return self
  }()
}
